const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const StudioProductStatusFlowReportQueryURL: any = {
    QueryStudioProductStatusFlowReport: Backofficebff + '/v1/studio-product-status-flow-report/query',
};
